// Dedicated workshop banks have one practice/progress path. Items are already
// access-filtered by the reader; this helper only removes identified bank links.
export function groupedFoundationQuizPool(items, introductionLessonId, supplementSourceIds = new Set()) {
    if (!Array.isArray(items)) return [];
    const excluded = new Set(supplementSourceIds instanceof Set ? [...supplementSourceIds].filter(id => typeof id === 'string' && id) : []);
    if (typeof introductionLessonId === 'string' && introductionLessonId) excluded.add(introductionLessonId);
    return items.filter(item => !excluded.has(item?.content?.relatedTextId));
}
